export class TrustAddressModel {
    Id: number;
    Label: string;
    AddressLine1: String;
    AddressLine2: String;
    AddressLine3: String;
    Town: String;
    County: String;
    PostCode: String;
}




// WEBPACK FOOTER //
// ./src/app/models/trust-address.ts